import React, {createContext, useContext, useState, useEffect} from 'react';
import Cookies from "universal-cookie";

export const userContext = createContext();

export const useUser = () =>{
    return useContext(userContext);
}

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState([]);

    useEffect(() => {
        const cookies = new Cookies();
        const userData = cookies.get('userdata');
        setUser(userData);
    }, []);

    return(
        <userContext.Provider value={{user, setUser}}>
            {children}
        </userContext.Provider>
    )
}